import { useState } from 'react'
import {
  useCreateNewService,
  useCreateNewSource,
  useDownloadServices,
  useDownloadSources,
  useFetchServices,
  useFetchSources,
} from '../../hooks/api'
import { toast } from 'react-toastify'
import { saveAs } from 'file-saver'
export const useSourceLogic = () => {
  const [filters, setFilters] = useState<Filters>({
    searchTerm: '',
    pageNumber: 1,
  })
  const serviceList = useFetchServices(filters)
  const sourceList = useFetchSources(filters)
  const createSource = useCreateNewSource()
  const createService = useCreateNewService()
  const downloadServices = useDownloadServices(filters)
  const downloadSources = useDownloadSources(filters)

  const handleDownloadServices = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    toast.dismiss()
    const loading = toast.loading(`Downloading Sources`)
    return downloadServices.mutate(undefined, {
      onSuccess: (response) => {
        saveAs(response, 'Services.csv')
      },
      onSettled: () => {
        toast.dismiss(loading)
      },
    })
  }
  const handleDownloadSources = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    toast.dismiss()
    const loading = toast.loading(`Downloading Sources`)
    return downloadSources.mutate(undefined, {
      onSuccess: (response) => {
        saveAs(response, 'Sources.csv')
      },
      onSettled: () => {
        toast.dismiss(loading)
      },
    })
  }

  return {
    sourceList,
    serviceList,
    createSource,
    createService,
    handleDownloadServices,
    handleDownloadSources,
    setFilters,
  }
}

export default useSourceLogic
